import Header from "@/components/Header";
import ObservationNewForm from "@/components/observations/ObservationNewForm";
import { useSiteName } from "@/hooks/useSiteName";
import type { LayoutContext } from "@/lib/models";
import { observationUrlBuilder } from "@/lib/url-builder";
import { useEffect } from "react";
import { useNavigate, useOutletContext, useParams, useSearchParams } from "react-router";

const ObservationCreatePage: React.FC = () => {
  const params = useParams();
  const { siteName } = useSiteName(params.siteId);
  const { setPageName } = useOutletContext<LayoutContext>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    setPageName(`Site: ${siteName} Create Observation`);
  }, [siteName, setPageName]);

  return (
    <div className="container mx-auto p-4">
      <Header headerTitle={`Feature: ${siteName}`} />
      <ObservationNewForm 
        featureId={searchParams.get("featureId")!} 
        showFooter={true}
        onClose={(observation => {
          if (!observation) {
            return;
          }
          navigate(observationUrlBuilder(params.siteId!, observation.id))
      })} />
    </div>
  );
};

export default ObservationCreatePage;
